import Vue from 'vue'
// import VueCompositionAPI from '@vue/composition-api'//
import { createI18n } from 'vue-i18n-bridge'

import VueI18n from 'vue-i18n'
import pt from "../../i18n/pt.json"
import en from "../../i18n/en.json"

// Vue.use(VueCompositionAPI)
Vue.use(VueI18n, { bridge: true }) // you must specify '{ bridge: true }' plugin option when install vue-i18n


const i18n = createI18n({
    legacy: false,
    locale: 'pt',
    messages: {
      pt,
      en
    }
  }, VueI18n)

  Vue.use(i18n)

  export {i18n}